import axios from 'axios';

export interface AppError {
  message: string;
  statusCode: number;
  details?: string[];
}

export function normalizeError(error: unknown): AppError {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    return {
      message: Array.isArray(data?.message) ? data.message[0] : data?.message || error.message,
      statusCode: error.response?.status || 500,
      details: Array.isArray(data?.message) ? data.message : undefined,
    };
  }
  return { message: 'An unexpected error occurred', statusCode: 500 };
}
